import { ArrowTopRightOnSquareIcon } from '@heroicons/react/24/outline';
import { cn } from '@utils/cn';
import { forwardRef } from 'react';
import { Link } from 'react-router';

import { type DetailLinkProps, type DetailLinkRef } from './types';

const DetailLink = forwardRef<DetailLinkRef, DetailLinkProps>(
  ({ className, children, ...props }, ref) => {
    return (
      <Link
        className={cn(
          'flex items-center justify-start gap-2 font-semibold hover:underline',
          className,
        )}
        ref={ref}
        {...props}
      >
        <span className="sr-only">Ver detalle</span>
        {children}
        <ArrowTopRightOnSquareIcon
          className="size-[1.2em] stroke-2"
          role="img"
        />
      </Link>
    );
  },
);

DetailLink.displayName = 'DetailButton';

export { DetailLink };
